import {Button, Modal, ModalHeader, ModalContent, Dropdown, Grid} from "semantic-ui-react"
import {useEffect, useState, useRef} from 'react'
import {ActionButton} from "../common"
import {getCSRFToken, fetchWithAuth } from '../auth';

export const AddTeams = props => {
    const [open, setOpen] = useState(false)
    const [availableMembers, setAvailableMembers] = useState([]);
    const [teamTypes, setTeamTypes] = useState([]);
    const [selectedTeamType, setSelectedTeamType] = useState(null);
    const [markets, setMarkets] = useState([]);
    const [selectedMarket, setSelectedMarket] = useState(null);
    const [modalContent, setModalContent] = useState(<></>)
    const [selectedMembers, setSelectedMembers] = useState([]);
    const addTeamInfo = {
        'name': useRef()
    }

    useEffect(() => {
        refreshModal()
    }, [availableMembers, selectedMembers, teamTypes, selectedTeamType, markets, selectedMarket])

    const getAvailableMembers = async () => {
        const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'availablemembers/', {
         headers:{'X-CSRFToken': getCSRFToken()},
         credentials: 'include'
        })
        const respJson = await resp.json()
        setAvailableMembers(respJson)
    }

    const getTeamTypes = async () => {
        const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'team-types/', {
         headers:{'X-CSRFToken': getCSRFToken()},
         credentials: 'include'
        })
        const respJson = await resp.json()
        setTeamTypes(respJson)
    }

    const getMarkets = async () => {
        const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'teams/markets/', {
            headers: { 'X-CSRFToken': getCSRFToken() },
            credentials: 'include'
        })
        const respJson = await resp.json()
        setMarkets(respJson)
    }


    useEffect(() => {
        getAvailableMembers()
        getTeamTypes()
        getMarkets()
    }, [])

    const updateSelectedMembers = (event, data) => {
        setSelectedMembers(data.value)
    }

    const closeModal = () => {
        setOpen(false)
        refreshModal()
        setSelectedMembers([])
        setSelectedTeamType(null)
        setSelectedMarket(null)
    }

    function addTeam() {
        const name = addTeamInfo['name'].current.value
        const members = selectedMembers
        async function addTeamPost() {
            const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'teams/', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'X-CSRFToken': getCSRFToken()
                },

                credentials: 'include',
                body: JSON.stringify({
                    name: name,
                    members: members,
                    teamTypeId: selectedTeamType,
                    marketId: selectedMarket
                })
            })
            if(resp.status >= 400) {
                const respText = await resp.text()
                setModalContent((
                    <div style={{margin: "1rem", display: "flex", flexDirection: "column", alignItems: "center"}}>
                        <div>
                            There was an error: {respText}
                        </div>
                        <Button onClick={closeModal}>Close</Button>
                    </div>
                ))
            } else {
                setModalContent((
                    <div style={{margin: "2rem", display: "flex", flexDirection: "column", alignItems: "center"}}>
                        <div>
                            Success!
                        </div>
                        <Button style={{margin: "1rem"}} onClick={closeModal}>Close</Button>
                    </div>
                ))
            }
            props.refresh()
        }
        addTeamPost()
    }

    function refreshModal() {
        const content = (
            <>
                <ModalHeader>Add Team</ModalHeader>
                <ModalContent>
                    <div className="add-member-wrapper">
                        <div className="add-member">
                            <Grid>
                                <Grid.Row centered>
                                    <Grid.Column>
                                        <input type="text" required={true} name="Name" ref={addTeamInfo['name']}
                                               className="field-input spaced" placeholder="Name"></input></Grid.Column>
                                </Grid.Row>
                                <Grid.Row centered>
                                    <Grid.Column width={15}>
                                        <Dropdown 
                                            placeholder="Team Type" 
                                            value={selectedTeamType} 
                                            onChange={(e, data) => setSelectedTeamType(data.value)} 
                                            fluid 
                                            search 
                                            selection
                                            clearable
                                            options={
                                                teamTypes.map(type => ({
                                                    key: type.id,
                                                    value: type.id,
                                                    text: type.name
                                                }))
                                            }/>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row centered>
                                    <Grid.Column width={15}>
                                        <Dropdown
                                            placeholder="Market"
                                            value={selectedMarket}
                                            onChange={(e, data) => setSelectedMarket(data.value || null)}
                                            fluid
                                            search
                                            selection
                                            clearable
                                            options={
                                                markets.map(m => ({
                                                    key: m.id,
                                                    value: m.id,
                                                    text: m.label
                                                }))
                                            }/>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row centered>
                                    <Grid.Column width={15}>
                                        <Dropdown placeholder="Members" value={selectedMembers} onChange={updateSelectedMembers} fluid multiple search selection
                                              options={
                                                  availableMembers.map(member => {
                                                      return {
                                                          key: member.userId,
                                                          value: member.userId,
                                                          text: member.name
                                                      }
                                                  })
                                              }/>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row centered> <Grid.Column width={8}><ActionButton
                                   submitAction={addTeam}
                                          resetHide={false}
                                          resetText={'Cancel'}
                                          showConfirmation={false}
                                          resetAction={() => setOpen(false)}
                                />
                                </Grid.Column></Grid.Row>
                            </Grid>

                        </div>
                    </div>
                </ModalContent>
            </>)
        setModalContent(content)
    }

    return (<Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        size={'mini'}
        trigger={<Button style={{backgroundColor: "var(--add)", color: "white"}}>Add Team</Button>}
    >{modalContent}</Modal>)
}
